import axios from "axios";
import React, { useEffect, useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { BsArrowLeft } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../Components/Global/Loader";
import DashboardLayouts from "../Components/Layout/DashboardLayouts";
import { useAuth } from "../Context/AuthContext";
import useAxiosFetch from "../hooks/useAxiosFetch";
import useToastify from "../hooks/useToastify";


function ChangePassword() {

    // api api from global hook 

  const { axiosFetch} = useAxiosFetch();
  const { designation } = useAuth();

    // show toast hook 
  const { notify } = useToastify();;
  const { Logout, isAuthenticated, setBuildingCount, setUnitCount, userRole } =
    useAuth();
  const [userDetails, setUserDetails] = useState(false);
  const [loading, setLoading] = useState(false);
  const route = useNavigate();
  const [passwordError, setpasswordError] = useState();
  const [changepassword, setChangePassword] = useState({
    id: "",
    old_password: "",
    old_password_type: "password",
    new_password: "",
    new_password_type: "password",
    confirm_password: "",
    confirm_password_type: "password",
  });
  const { id, old_password, new_password, confirm_password, confirm_password_type, new_password_type, old_password_type } = changepassword;





  //get user details from API

  useEffect(() => {
    if (isAuthenticated) {
      axiosFetch({
        axiosInstance: axios,
        method: 'GET',
        url: `/userDetails`,


      })
        .then((response) => {
          if (response?.data) {
            setUserDetails(response.data?.UserDetails);
            setBuildingCount(response.data?.BuildingCount);
            setUnitCount(response.data?.UnitCount);
          }
        })
        .catch((e) => {
          setLoading(false);
          Logout()
        });
    }
  }, [isAuthenticated]);

  //State update function

  const PasswordChangeFunc = (e) => {
    const value = e.target.value;
    setChangePassword({ ...changepassword, [e.target.name]: value });
    setpasswordError("");
  };


  //State update function

  const ResetPasswordFunc = (e) => {
    e.preventDefault();
    var data1 = changepassword;
    data1 = {
      ...changepassword,
      id: userDetails?.id,
      old_password,
      new_password,
      confirm_password,
    };
    if (userDetails?.id) {
      
      axiosFetch({
        axiosInstance: axios,
        method: 'POST',
        url: "/resetpassword",
        requestConfig: data1,
        navigatesUrl: designation === "Owner" || designation === "Partner"
        ? "/dashboard"
        : `/${designation}dashboard`.toLowerCase()

      })
        .then(function (response) {
          notify("Password changed successfully", "success");
        
        })
        .catch(function (error) {
          if (error.response.status === 401) {
            setpasswordError(error.response.data);
          }
        });
    }
  };

  return (
    <>
      {loading && <Loader />}
      <DashboardLayouts>
        <div className="login_form custom__form-a">
          <form className="form-area">
            <h1 className="mb-xl-5 mb-lg-4 mb-md-3 text-center">
              Reset Password
            </h1>
            <div className="row gy-4">
              <div className="form-group ">
                <label htmlFor="" className="form-lbl">
                  Old Password
                </label>
                <div className="position-relative">
                  <input
                    type={old_password_type}
                    name="old_password"
                    value={old_password}
                    onChange={(e) => PasswordChangeFunc(e)}
                    className="form-control form-g1"
                    placeholder="Old Password"
                  />
                  <div className="position-absolute top-50 start-100 translate-middle pe-5" onClick={() => { setChangePassword({ ...changepassword, old_password_type: old_password_type == "text" ? "password" : "text" }) }}>
                    {old_password_type == "text" ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                  </div>

                </div>

              </div>
              <div className="form-group">
                <label htmlFor="" className="form-lbl">
                  New Password
                </label>
                <div className="position-relative">

                  <input
                    type={new_password_type}
                    name="new_password"
                    value={new_password}
                    onChange={(e) => PasswordChangeFunc(e)}
                    className="form-control form-g1"
                    placeholder={`create password`}
                  />
                  <div className="position-absolute top-50 start-100 translate-middle pe-5" onClick={() => { setChangePassword({ ...changepassword, new_password_type: new_password_type == "text" ? "password" : "text" }) }}>
                    {new_password_type == "text" ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}

                  </div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="" className="form-lbl">
                  Confirm New Password
                </label>
                <div className="position-relative">

                  <input
                    type={confirm_password_type}
                    name="confirm_password"
                    value={confirm_password}
                    onChange={(e) => PasswordChangeFunc(e)}
                    className="form-control form-g1"
                    placeholder={`confirm your password`}
                  />
                  <div className="position-absolute top-50 start-100 translate-middle pe-5" onClick={() => { setChangePassword({ ...changepassword, confirm_password_type: confirm_password_type == "text" ? "password" : "text" }) }}>
                    {confirm_password_type == "text" ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                  </div>
                </div>
              </div>

              <div className="my-4">
                <button
                  type="submit"
                  className="btn btn-primary btn-lg login-btn w-100"
                  onClick={(e) => ResetPasswordFunc(e)}
                >
                  Update Password
                </button>
              </div>
              {passwordError ? (
                <p className="mt-2 text-center pass-incorrect-msg  text-danger">
                  {passwordError}
                </p>
              ) : null}
            </div>
          </form>
          <div className="d-flex justify-content-center">
            <Link
              to={
                userRole === "Owner" || userRole === "Partner"
                  ? "/dashboard"
                  : `/${userRole}dashboard`.toLowerCase()
              }
              className="back-link back_to_login justify-content-center"
            >
              <BsArrowLeft className="me-2 back-arrow m-0 " color="#0064BB" />
              <h3 className="mb-0">Back To Dashboard</h3>
            </Link>
          </div>
        </div>
      </DashboardLayouts >
    </>
  );
}

export default ChangePassword;
